module.exports = __webpack_public_path__ + "img/tooltip_07-vallone-wood-rovere-termocotto-02.e973d844.jpg";